import { render } from "./PowerSimulator.vue?vue&type=template&id=743f672f&scoped=true&ts=true"
import script from "./PowerSimulator.vue?vue&type=script&setup=true&lang=ts"
export * from "./PowerSimulator.vue?vue&type=script&setup=true&lang=ts"

import "./PowerSimulator.vue?vue&type=style&index=0&id=743f672f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743f672f"],['__file',"src/components/PowerSimulator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "743f672f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('743f672f', __exports__)) {
    api.reload('743f672f', __exports__)
  }
  
  module.hot.accept("./PowerSimulator.vue?vue&type=template&id=743f672f&scoped=true&ts=true", () => {
    api.rerender('743f672f', render)
  })

}


export default __exports__